import { render } from "./PreFooter.vue?vue&type=template&id=90e5053c&scoped=true"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"

import "./PreFooter.vue?vue&type=style&index=0&id=90e5053c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e5053c"]])

export default __exports__